<template>
  <div class="features-container">
    <v-row dense>
      <v-col
        :class="getCardContainerClass(n)"
        v-for="n in plans"
        :key="n.title" 
      >
        <v-card max-width="600" :class="getCardClass(n)">
          <div class="card_border_top_container" />
          <div class="card_border_top" v-if="n.bordered">
            {{ n.border_top_text }}
          </div>
          <v-card-text class="feature_card card-height">
            <img
              v-if="n.name == 'deluxe'"
              class="egyn-feature-logo"
              src="../../assets/deluxe.svg"
            />
            <img
              v-if="n.name == 'premium'"
              class="egyn-feature-logo"
              src="../../assets/premium.svg"
            />
            <img
              v-if="n.name == 'base'"
              class="egyn-feature-logo"
              src="../../assets/standard.svg"
            />

            <v-container class="price_container">
              <v-row class="price_price"
                ><v-col
                  ><span class="price_eur">{{ getPrice(n) }}</span></v-col
                ></v-row
              >
            </v-container>

            <ul class="text-center plan_list_style">
              <li class="features" v-for="i in n.features" :key="i.title">
                <div style="height:5px" />
                <span v-if="i.title" class="plan_list_title">{{ i.title }}</span
                ><BR /><span
                  v-if="i.description"
                  class="plan_list_description"
                  >{{ i.description }}</span
                >
                <div style="height:5px" />
                <v-divider />
              </li>
            </ul>
            <div style="height:30px" />
            <span class="card-footer"
              >Costi di registrazione dominio, certificati SSL, spazio web,
              webmail e accesso al pannello di controllo primo anno gratuiti,
              rinnovo 250€</span
            >
          </v-card-text>
          <v-btn
            v-if="!featureSelected"
            @click="previewFeature(n, $event)"
            color="#b083a8"
            class="white--text preview_feature"
            >ANTEPRIMA</v-btn
          >

          <v-btn
            v-if="!featureSelected"
            @click="pickFeature(n, $event)"
            color="primary"
            class="pick_feature"
            >SCEGLI</v-btn
          >
        </v-card>
      </v-col>
    </v-row>
    <v-progress-circular
      v-if="featureSelected"
      :indeterminate="true"
      :rotate="0"
      :size="32"
      :width="4"
      color="light-blue"
    ></v-progress-circular>
  </div>
</template>

<script>
import store from "../../store/index";
import config from "../../config";

export default {
  data() {
    return {
      featureSelected: false,
      plans: [
        {
          title: "> BASE <",
          price_header: "prezzo speciale",
          price: config.basePayoutPrice,
          bordered: false,
          border_top_text: null,
          features: [
            {
              title: "Sito singola pagina + scelta fra 6 stili grafici",
              /*description:
                "Visualizzazione ottimizzata per Devices mobile, scelta tra 6 stili grafici",*/
            },
            {
              title: "Registrazione dominio + 1 casella mail personalizzata",
              //description: "Certificato SSL incluso",
            },
            {
              title: "Localizzazione GoogleMaps indirizzi di ricevimento",
              //description: "",
            },
            {
              title: "Gestione contenuti testi e immagini",
              //description: "Upload autonomo immagini Medico/Studio",
            },
            {
              title: "Vasta Libreria di foto a disposizione",
              //description:
              //  "Potrai selezionare 6 tra i servizi che offri, da mettere in evidenza nella Home",
            },
            /* {
              title: "Fino a 4 indirizzi Studio Medico e/o Ospedale",
              description:
                "Localizzazione mappa google-maps per indirizzi ricevimento",
            },*/
          ],
          name: "base",
        },
        {
          featured: "IL PIÙ VENDUTO!",
          title: "> PREMIUM <",
          price_header: "prezzo speciale",
          price: config.premiumPayoutPrice,
          bordered: true,
          border_top_text: "IL PIÙ VENDUTO",
          features: [
            {
              title: " Tutte le caratteristiche dello STANDARD +",
              //   description: "Visualizzazione ottimizzata per Devices mobile, scelta tra 6 stili grafici",
            },
            {
              title: "Sito multipagina (home, servizi, chi sono, contatti)",
              //  description: "Certificato SSL incluso",
            },
            {
              title: "3 caselle email personalizzate",
              // description: "",
            },
            {
              title: "Libreria articoli scientifici",
              // description: "Upload autonomo immagini Medico/Studio",
            },
            {
              title: "Modulo prenotazione appuntamento",
              //   description:
              //    "Localizzazione mappa google-maps per indirizzi ricevimento",
            },
          ],
          name: "premium",
        },
        {
          title: "> DELUXE <",
          price_header: "prezzo speciale",
          price: config.deluxePayoutPrice,
          bordered: false,
          border_top_text: null,
          features: [
            {
              title: "Tutte le caratteristiche del PREMIUM +",
              //   description: "Le features del piano premium sono a tua disposizione",
            },
            {
              title: "Creazione Logo",
              //  description: "La realizzazione del tuo logo verrà affidata ad un' agenzia specializzata",
            },
            {
              title: "Libreria 50 Foto Extra alta risoluzione",
              // description: "Avrai a disposizione una libreria professionale di immagini con oltre 1.000.000 di foto",
            },
            {
              title: "Posizionamento Seo (Search engine optimization)",
              // description: "Migliora la visibilità e il posizionamento web del tuo sito ottimizzando i contenuti.",
            },
            {
              title: "Sponsorizzata una tantum in Facebook  Business Manager",
              // description: "Migliora la visibilità e il posizionamento web del tuo sito ottimizzando i contenuti.",
            },
          ],
          name: "deluxe",
        },
      ],
    };
  },

  methods: {
    getPrice(n) {
      return new Intl.NumberFormat("it-IT").format(n.price) + ",00 €";
    },

    getCardContainerClass() {
      return "bordered_card_container ";
    },

    getCardClass(n) {
      let classes = "";
      if (n.bordered) classes = "bordered_card ";
      if (n.name == "base") classes += "elevation-3 ml-auto";
      else if (n.name == "premium") classes += "elevation-3 ml-auto mr-auto";
      else if (n.name == "deluxe") classes += "elevation-3 mr-auto";
      return classes;
    },

    pickFeature(item) {
      this.featureSelected = true;
      let completedStep = this.$store.state.wizard.completedStep;
      if (completedStep < this.$store.state.wizard.selectedStep)
        completedStep = this.$store.state.wizard.selectedStep;
      store
        .dispatch("setWizardSteps", {
          completedStep: completedStep,
          selectedStep: this.$store.state.wizard.selectedStep + 1,
          meta: { feature: item.name },
        })
        .then(() => {
          this.featureSelected = false;
        });
    },

    previewFeature(item) {
      let thisURl = window.location.origin;
      let url = thisURl + "/previews/" +config.appPath + "/" + item.name + "/03/index.html";
      window.open(url.replace("/deluxe", "/premium"));
    },
  },
};
</script>

<style scoped>
.features-container {
}

.bordered_card_container {
  padding-top: 40px;
  padding-bottom: 40px;
}

.card_border_top_container {
  position: relative;
  bottom: 0;
  left: 0;
}

.card_border_top {
  position: absolute;
  z-index: 100;
  font-size: 20px;
  background: linear-gradient(
    0deg,
    rgba(118, 162, 187, 1) 0%,
    rgba(138, 193, 223, 1) 100%
  );
  color: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  top: -50px;
  bottom: 0;
  height: 40px;
  padding: 10px;
  font-weight: bold;
}

.bordered_card {
  border: 10px solid #76a2bb;
}

.card-footer {
  color: #74a2bc;
  font-weight: bold;
}

.plan_list_style {
  list-style-type: none;
}

.plan_list_title {
  font-size: 16px;
  font-weight: bold;
  color: #b083a8;
}

.plan_list_description {
  font-size: 14px;
  font-weight: bold;
  color: gray;
}

.feature_title {
  color: #1d7b8a;
  font-weight: bold;
  margin-top: 10px;
}

.feature_card {
  min-height: 600px;
}

.price_container {
  background-color: #74a2bc;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 0px;
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 10px;
  color: white;
}

.price_header {
  text-transform: uppercase;
  font-weight: 500;
}

.price_price {
  text-transform: uppercase;
  font-weight: 400;
  font-size: 2.5em;
}

.price_eur {
}

.price_vat {
  text-transform: uppercase;
  font-weight: 400;
  font-size: 0.5em;
  padding-left: 10px;
}

.features {
  font-weight: 500;
  margin-bottom: 10px;
}

.pick_feature {
  margin-bottom: 10px;
  text-transform: uppercase;
  width: 200px;
}

.preview_feature {
  margin-bottom: 10px;
  margin-right: 5px;
  text-transform: uppercase;
  width: 200px;
}

.pick_button {
  text-transform: uppercase;
}

.egyn-feature-logo {
  height: 60px;
}
</style>
